export default "__VITE_ASSET__EnkW7sMN__"